import React, { useState } from 'react';
import { ArrowLeft, LogIn } from 'lucide-react';
import { toast } from 'sonner';

const AdminLoginForm = ({ onLogin, loading }) => {
  const [token, setToken] = useState('');

  const submit = async () => {
    if (!token.trim()) return toast.error('Vnesite admin token');
    try {
      await onLogin(token);
      setToken('');
    } catch (error) {
      toast.error(error.message || 'Prijava ni uspela');
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F2EA] flex items-center justify-center px-6">
      <div className="bg-white p-8 max-w-md w-full border border-[#E2DACB]" data-testid="admin-login-panel">
        <div className="flex items-center gap-3 mb-6">
          <a href="/" className="text-[#7A5B28] hover:text-[#5C431C]" data-testid="admin-login-home-link" aria-label="Nazaj na domačo stran"><ArrowLeft className="w-5 h-5" /></a>
          <h1 className="font-serif text-2xl text-[#15181C]">Admin Panel</h1>
        </div>
        <p className="text-[#4E5359] mb-6">Vnesite admin token. Podatek se po prijavi ne shrani v brskalnik.</p>
        <label htmlFor="admin-token" className="block text-sm font-medium text-[#4E5359] mb-1">Admin token</label>
        <input id="admin-token" type="password" value={token} onChange={(event) => setToken(event.target.value)} onKeyDown={(event) => event.key === 'Enter' && submit()} className="w-full h-12 border border-[#CFC7B8] px-4 focus:outline-none focus:border-[#C9A462]" data-testid="admin-token-input" autoComplete="current-password" />
        <button onClick={submit} disabled={loading} className="mt-4 w-full h-12 bg-[#0E1114] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#1a1f25] disabled:opacity-50" data-testid="admin-login-button"><LogIn className="w-5 h-5" />{loading ? 'Prijava…' : 'Prijava'}</button>
      </div>
    </div>
  );
};

export default AdminLoginForm;